import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import Tooltip from '../tooltip';

const Time = styled.time`
	color: ${({ theme, ...props }) => theme[props.color]};
	font-size: ${(props) => `${props.size}rem`};
	white-space: nowrap;
`;

function Duration({ timestamp, color = 'silver-base', size = 1 }) {
	const [now, setNow] = useState(moment());

	useEffect(() => {
		const timer = setTimeout(() => {
			setNow(moment());
		}, 60000);
		return () => clearTimeout(timer);
	});

	const getDuration = (timestamp) => {
		const time = moment.unix(timestamp);
		const diffDuration = moment.duration(time.diff(now));

		if( now.diff(time) < moment.duration(1, 'minutes').as('milliseconds') ) {
			return 'Just Now';
		}

		return moment.duration(diffDuration).humanize(true);
	};

	return (
		<Tooltip text={moment.unix(timestamp).format('LLL')} delay>
			<Time
				dateTime={moment.unix(timestamp).format('YYYY-MM-DDTHH:mm:ssZ')}
				color={color}
				size={size}
				data-testid="time"
			>
				{getDuration(timestamp)}
			</Time>
		</Tooltip>
	);
}

Duration.propTypes = {
	timestamp: PropTypes.number.isRequired,
	color: PropTypes.string,
	size: PropTypes.number
};

export default Duration;
